import { render } from "./Pagination.vue?vue&type=template&id=2256c562"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=2256c562&lang=css"

import exportComponent from "C:\\Users\\Light\\Documents\\Projects\\PHP-Laravel\\TatSingWeb\\ts-group\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__